<div class="notfound_container">
  <img src="./assets/images/logoWhite.svg" class="notfound_image" alt="Olleyes logo" />
  <div class="text--center">{{ errorMessage | translate }}</div>
  <br>
</div>
